import { cn } from "../../lib/utils";

const variants = {
	size: {
		small: {
			btn: "py-2 px-3",
		},
	},
	theme: {
		dark: {
			container: "bg-dark-10",
		},
		light: {
			container: "bg-white ring-1 ring-dark-30",
			btn: "text-dark-50 ",
		},
	},
	selected: {
		dark: {
			btn: "bg-white text-dark-70 shadow-[0_1px_1px] shadow-dark-100/10",
		},
		light: {
			btn: "bg-white text-dark-70 ring-1 ring-interactive-70",
		},
	},
	rounded: {
		sm: {
			container: "rounded-[4px]",
			btn: "rounded-sm",
		},
		full: {
			container: "rounded-full",
			btn: "rounded-full",
		},
	},
};

const Tabs = ({ options, onChange, selected, size, theme = "dark", rounded = "full" }) => {
	return (
		<div
			className={cn(
				"bg-dark-10 p-[4px] flex",
				variants.theme?.[theme]?.container,
				variants.rounded?.[rounded]?.container
			)}
		>
			{options.map((item, index) => (
				<button
					key={item.value}
					type="button"
					onClick={() => onChange(item.value)}
					className={cn(
						"text-dark-50 font-bold py-3 px-4 flex-1",
						variants.size?.[size]?.btn,
						variants.rounded?.[rounded]?.btn,
						variants.theme?.[theme]?.btn,
						selected === item.value && variants.selected?.[theme]?.btn
					)}
				>
					{item.label}
				</button>
			))}
		</div>
	);
};

export default Tabs;
